module.exports = __webpack_public_path__ + "img/hangzhou_screen.97ed8d7e.png";